// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import Container from "../layout/container"
import Content from "../../content/about-us/nos-valeurs.json"
import { colors } from "../../utils/theme/colors"
import { fontWeights } from "../../utils/theme/font-weights"
import NosValeursCards from "./nos-values-cards"
import NosValeursText from "./nos-values-text"

const NosValeurs = ({ langKey }) => {
  const { title } = Content[langKey]

  return (
    <Container>
      <div
        sx={{
          display: `flex`,
          flexDirection: `column`,
          marginTop: `3rem`,
          alignItems: `center`,
        }}
      >
        <div
          sx={{
            width: `0`,
            height: [`3rem`, `3rem`, `7.3rem`, `7.3rem`],
            objectFit: `contain`,
            border: `solid 1px`,
            margin: `auto`,
            color: colors.code.primary,
            my: `30px`,
          }}
        />

        <h2
          sx={{
            color: colors.code.secondary,
            fontSize: [`1.37rem`, `1.37rem`, `2.25rem`, `2.25rem`],
            fontWeight: fontWeights.black,
            textAlign: `center`,
          }}
        >
          {title}
        </h2>
        <div>
          <NosValeursCards
            langKey={langKey}
            overrideCSS={{
              position: "relative",
              zIndex: 2,
              top: `35px`,
              left: "90px",
            }}
          />
          <NosValeursText langKey={langKey} />
        </div>
      </div>
    </Container>
  )
}

export default NosValeurs
